import React from 'react';
import AntLocalization from '../../utils/AntLocalization';
import './index.scss';

// ─── Chiều cao thanh biểu đồ (cố định, không random để React không diff thừa) ───
var CHART_BARS = [46, 72, 38, 88, 60, 78, 44, 92, 55, 68, 40, 82];
var LABEL_WIDTHS = [70, 55, 62, 48, 66, 58, 72, 50];
var COL_WIDTHS = [30, 24, 26, 20];

var T_NO_DATA = {
    vi: 'Chưa có dữ liệu',
    en: 'No data',
    fr: 'Aucune donnée',
    es: 'Sin datos',
    id: 'Belum ada data',
    ja: 'データなし',
    zh: '暂无数据',
    ko: '데이터 없음',
    hi: 'कोई डेटा नहीं',
    ar: 'لا توجد بيانات'
};

// ─── Trạng thái rỗng: giữ nguyên khung, chỉ hiện chữ ──────────────────
export function AntWidgetEmpty(props) {
    var style = {};
    if (props.height) style.minHeight = props.height;
    return (
        <div className="ant-widget-empty" style={style}>
            <span className="ant-widget-empty__text">{AntLocalization.translateText(props.text || T_NO_DATA)}</span>
        </div>
    );
}

function times(n) {
    return Array.from({ length: Math.max(n | 0, 0) }, function (_, i) {
        return i;
    });
}

function renderChart(props) {
    var n = props.columns || 12;
    return (
        <div className="ant-sk-chart">
            <div className="ant-sk-chart__bars">
                {times(n).map(function (i) {
                    return <span key={i} className="ant-sk ant-sk-chart__bar" style={{ height: CHART_BARS[i % CHART_BARS.length] + '%' }} />;
                })}
            </div>
            <span className="ant-sk ant-sk-chart__axis" />
        </div>
    );
}

function renderDoughnut() {
    return (
        <div className="ant-sk-doughnut">
            <span className="ant-sk ant-sk-doughnut__ring">
                <span className="ant-sk-doughnut__hole" />
            </span>
            <div className="ant-sk-doughnut__legend">
                {times(3).map(function (i) {
                    return <span key={i} className="ant-sk ant-sk-doughnut__legend-item" />;
                })}
            </div>
        </div>
    );
}

function renderRows(props) {
    var n = props.rows || 5;
    return (
        <div className="ant-sk-rows">
            <div className="ant-sk-rows__row ant-sk-rows__row--head">
                {COL_WIDTHS.map(function (w, c) {
                    return <span key={c} className="ant-sk ant-sk-rows__cell" style={{ width: w + '%' }} />;
                })}
            </div>
            {times(n).map(function (i) {
                return (
                    <div key={i} className="ant-sk-rows__row">
                        {COL_WIDTHS.map(function (w, c) {
                            return <span key={c} className="ant-sk ant-sk-rows__cell" style={{ width: w + '%' }} />;
                        })}
                    </div>
                );
            })}
        </div>
    );
}

function renderStat(props) {
    var n = props.count || 4;
    return (
        <div className="ant-sk-stat">
            {times(n).map(function (i) {
                return (
                    <div key={i} className="ant-sk-stat__cell">
                        <span className="ant-sk ant-sk-stat__value" />
                        <span className="ant-sk ant-sk-stat__caption" />
                    </div>
                );
            })}
        </div>
    );
}

function renderMetric() {
    return (
        <div className="ant-sk-metric">
            <span className="ant-sk ant-sk-metric__caption" />
            <span className="ant-sk ant-sk-metric__value" />
            <span className="ant-sk ant-sk-metric__compare" />
        </div>
    );
}

function renderList(props) {
    var n = props.rows || 5;
    var showBars = props.showBars !== false;
    return (
        <div className="ant-sk-list">
            {times(n).map(function (i) {
                return (
                    <div key={i} className="ant-sk-list__row">
                        <div className="ant-sk-list__main">
                            <span className="ant-sk ant-sk-list__label" style={{ width: LABEL_WIDTHS[i % LABEL_WIDTHS.length] + '%' }} />
                            <span className="ant-sk ant-sk-list__value" />
                        </div>
                        {showBars && <span className="ant-sk ant-sk-list__bar" />}
                    </div>
                );
            })}
        </div>
    );
}

function renderTimeline(props) {
    var n = props.rows || 4;
    return (
        <div className="ant-sk-timeline">
            {times(n).map(function (i) {
                return (
                    <div key={i} className="ant-sk-timeline__item">
                        <span className="ant-sk ant-sk-timeline__time" />
                        <span className="ant-sk ant-sk-timeline__dot" />
                        <div className="ant-sk-timeline__content">
                            <span className="ant-sk ant-sk-timeline__title" style={{ width: LABEL_WIDTHS[i % LABEL_WIDTHS.length] + '%' }} />
                            <span className="ant-sk ant-sk-timeline__subtitle" />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

function renderGauge(props) {
    var n = props.count || 1;
    var size = props.gaugeSize || 100;
    return (
        <div className="ant-sk-gauge">
            {times(n).map(function (i) {
                return (
                    <span key={i} className="ant-sk ant-sk-gauge__ring" style={{ width: size, height: size }}>
                        <span className="ant-sk-gauge__hole" />
                    </span>
                );
            })}
        </div>
    );
}

// Lưới ô vuông (bản đồ nhiệt theo giờ / theo lịch): ô phẳng, hiệu ứng đặt ở khung
// ngoài để không chạy 168 hoạt ảnh cùng lúc.
function renderCells(rowCount, colCount, modifier) {
    return (
        <div className={'ant-sk-cells ant-sk-cells--' + modifier}>
            {times(rowCount).map(function (r) {
                return (
                    <div key={r} className="ant-sk-cells__row">
                        {times(colCount).map(function (c) {
                            return <span key={c} className="ant-sk-cells__cell" />;
                        })}
                    </div>
                );
            })}
        </div>
    );
}

function renderBody(variant, props) {
    switch (variant) {
        case 'chart':
            return renderChart(props);
        case 'doughnut':
            return renderDoughnut();
        case 'grid':
        case 'pivot':
            return renderRows(props);
        case 'stat':
            return renderStat(props);
        case 'metric':
            return renderMetric();
        case 'infopanel':
        case 'list':
            return renderList(props);
        case 'timeline':
            return renderTimeline(props);
        case 'gauge':
            return renderGauge(props);
        case 'heatmap':
            return renderCells(7, 24, 'heatmap');
        case 'calendar':
            return renderCells(7, props.columns || 16, 'calendar');
        default:
            return renderList(props);
    }
}

/**
 * Khung xám mờ giữ đúng chỗ của một widget dashboard trong lúc chờ dữ liệu.
 *
 * variant: chart | doughnut | grid | pivot | stat | metric | infopanel | list |
 *          timeline | gauge | heatmap | calendar
 * overlay: đặt đè lên widget đang tự tải (biểu đồ, bảng) thay vì thay thế nó.
 */
export default function AntWidgetSkeleton(props) {
    var variant = props.variant || 'list';
    var cls = ['ant-widget-skeleton', 'ant-widget-skeleton--' + variant];
    if (props.overlay) cls.push('ant-widget-skeleton--overlay');
    if (props.className) cls.push(props.className);

    var style = {};
    if (props.height) {
        if (props.overlay) style.minHeight = props.height;
        else style.height = props.height;
    }

    return (
        <div className={cls.join(' ')} style={style} aria-hidden="true">
            {renderBody(variant, props)}
        </div>
    );
}
